import React, { useMemo } from 'react';
import { QuotationNav } from './components/QuotationNav';
import { Hero } from './components/Hero';
import { OpportunitySection } from './components/OpportunitySection';
import { ApproachSection } from './components/ApproachSection';
import { ScopeSection } from './components/ScopeSection';
import { InvestmentSection } from './components/InvestmentSection';
import { NextStepsSection } from './components/NextStepsSection';
import { QuotationFooter } from './components/QuotationFooter';
import { lineItemGroups } from './data/quotation';
import { totalsFor } from './utils/pricing';
export function App() {
  const totals = useMemo(() => totalsFor(lineItemGroups), []);
  return <div className="min-h-screen w-full bg-white font-sans text-ink-900" data-id="element-0" data-mp="2wk9y4kb1ymz3">
      <QuotationNav total={totals.total} data-id="element-1" data-mp="2wi5lndz38fn7" />
      <main data-id="element-2" data-mp="28tmi1bqzgr1g">
        <Hero total={totals.total} campaigns={totals.campaigns} recurring={totals.annual} data-id="element-3" data-mp="28t4lsf4bmctj" />
        <OpportunitySection data-id="element-4" data-mp="23t8fuac2cbbc" />
        <ApproachSection data-id="element-5" data-mp="3ik7eyd5x05p2" />
        <ScopeSection data-id="element-6" data-mp="3iiweonbohg2p" />
        <InvestmentSection totals={totals} data-id="element-7" data-mp="3ijfthv617oci" />
        <NextStepsSection data-id="element-8" data-mp="3mlaxx8j9ehui" />
      </main>
      <QuotationFooter total={totals.total} data-id="element-9" data-mp="3mk85gw6ag7ch" />
    </div>;
}